import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import queryString from "query-string";
import { startResetPass } from "../actions/auth";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input, message } from "antd";
import Logo from "../assets/images/up-logo.svg";
import "../styles/components/login.scss";
import "../styles/components/button.scss";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pass: "",
      passAgain: ""
    };
  }
  queries = queryString.parse(this.props.location.search);
  onSubmit = e => {
    e.preventDefault();
    if (this.state.pass !== this.state.passAgain) {
      message.error("Passwords are not match");
    } else if (
      this.state.pass.length <= 0 ||
      this.state.passAgain.length <= 0
    ) {
      message.error("Please fill all fields");
    } else if (this.state.pass.length < 8 || this.state.passAgain.length < 8) {
      message.error("Your password must be at least 8 characters");
    } else {
      this.props.startResetPass(
        this.queries.token,
        this.queries.email,
        this.state.pass
      );
    }
  };

  onChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(() => ({ [name]: value }));
  };

  render() {
    return (
      <div className="box-layout__box">
        <img src={Logo} alt="logo" />
        <div className="box-layout__box__container">
          <div className="box-layout__box__header">
            <h2>Please enter your new password</h2>
            <p>{this.queries.email}</p>
          </div>
          <Form className="box-layout__form" onSubmit={this.onSubmit}>
            <div className="form-input">
              <label>Password</label>
              <Input.Password
                name="pass"
                placeholder="Password"
                value={this.state.pass}
                onChange={this.onChange}
                size="large"
              />
            </div>

            <div className="form-input">
              <label>Confirm Password</label>
              <Input.Password
                name="passAgain"
                placeholder="Repeat Password"
                value={this.state.passAgain}
                onChange={this.onChange}
                size="large"
              />
            </div>

            <div className="box-layout__other">
              <div className="login-button-container">
                <Button
                  className="button-login"
                  type="primary"
                  shape="round"
                  size="large"
                  loading={this.props.fetchInProgress}
                  htmlType="submit"
                >
                  Set new Password
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <div className="fancy-detour">
          <p>Already have an account?</p>
          <Link to="/login" className="button-guest">
            Login
          </Link>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  startResetPass: (token, email, password) =>
    dispatch(startResetPass(token, email, password))
});

const mapStateToProps = state => ({
  fetchInProgress: state.fetchInProgress
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);
